
// this file defines the Department enum used across the application
export enum Department {
    Exco = "Exco",
}